import { Link } from "react-router-dom";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import { Bars2Icon } from "@heroicons/react/24/outline";

const ExerciseTemplateCard = (props) => {
  let setsText = "0 Sets";
  if (props.sets && props.sets === 1) {
    setsText = "1 Set";
  } else if (props.sets && props.sets > 1) {
    setsText = `${props.sets} Sets`;
  }

  let repsText = "";
  if (props.repRange && props.repRange.min && props.repRange.max) {
    repsText = `${props.repRange.min}-${props.repRange.max} Reps`;
  } else if (props.repRange && props.repRange.min && !props.repRange.max) {
    repsText = `${props.repRange.min} Reps`;
  } else if (props.repRange && !props.repRange.min && props.repRange.max) {
    repsText = `${props.repRange.max} Reps`;
  }

  let restText = "";
  if (props.rest) {
    if ("min" in props.rest) {
      if (props.rest.min.minutes || props.rest.min.seconds) {
        restText += "Rest: ";
      }
    } else if ("max" in props.rest) {
      if (props.rest.max.minutes || props.rest.max.seconds) {
        restText += "Rest: ";
      }
    }
    if ("min" in props.rest) {
      if (props.rest.min.minutes) {
        restText += `${props.rest.min.minutes}m`;
      }
      if (props.rest.min.minutes && props.rest.min.seconds) {
        restText += ` `;
      }
      if (props.rest.min.seconds) {
        restText += `${props.rest.min.seconds}s`;
      }
    }
    if ("min" in props.rest && "max" in props.rest) {
      if (
        props.rest.min.minutes ||
        props.rest.min.seconds ||
        props.rest.max.minutes ||
        props.rest.max.seconds
      ) {
        restText += ` - `;
      }
    }
    if ("max" in props.rest) {
      if (props.rest.max.minutes) {
        restText += `${props.rest.max.minutes}m`;
      }
      if (props.rest.max.minutes && props.rest.max.seconds) {
        restText += ` `;
      }
      if (props.rest.max.seconds) {
        restText += `${props.rest.max.seconds}s`;
      }
    }
  }

  let tempoText = "";
  if (props.tempo) {
    if (
      props.tempo.eccentric ||
      props.tempo.stretchedPause ||
      props.tempo.concentric ||
      props.tempo.contractedPause
    ) {
      tempoText = `Tempo: ${
        props.tempo.eccentric ? props.tempo.eccentric : "0"
      }-${props.tempo.stretchedPause ? props.tempo.stretchedPause : "0"}-${
        props.tempo.concentric ? props.tempo.concentric : "0"
      }-${props.tempo.contractedPause ? props.tempo.contractedPause : "0"}`;
    }
  }

  const exerciseDetails = `${setsText}${
    repsText ? `\xa0|\xa0${repsText}` : ""
  }${restText ? `\xa0|\xa0${restText}` : ""}${
    tempoText ? `\xa0|\xa0${tempoText}` : ""
  }`;

  return (
    <div className={`relative ${props.className}`}>
      <Link
        to={`exercise-templates/${props._id}`}
        type="button"
        className="grid grid-cols-[auto_1fr] w-full bg-white rounded-md shadow-sm border border-gray-300"
      >
        <div className="h-full bg-gray-300 rounded-l-sm flex items-center p-2">
          <Bars2Icon className="h-5 text-gray-900" />
        </div>
        <div className="p-2 overflow-hidden pr-6">
          <h3 className="text-base font-medium text-gray-900 w-full whitespace-nowrap overflow-hidden text-ellipsis">
            {props.name || "Untitled Exercise"}
          </h3>
          <p className="text-xs text-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
            {exerciseDetails}
          </p>
        </div>
      </Link>
      <div className="absolute top-0 right-0">
        <DropdownMenu
          parentId={props._id}
          menuItems={["Delete"]}
          onDeleteClicked={props.onDeleteClicked}
        />
      </div>
    </div>
  );
};

export default ExerciseTemplateCard;
